import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import {setFixLevelLoading} from './LoadingReducer';

export const setFixLevel = createAction('SET_FIX_LEVEL');
export const loadFixLevelData = (action = {}) => (dispatch, getState) => {
  const {wo} = action;
  
  dispatch(setFixLevelLoading({loading: true}));
  axios.get(
      `/workdoc/damage?wo=${wo}&format=json`)
      .then((response) => {
        const damageData = (response.data && response.data.data) || {};
        dispatch(setFixLevel({
          data: damageData.fixlevel,
          payload: action,
        }));
        dispatch(setFixLevelLoading({loading: false}));
      })
      .catch((error) => {
        console.error(error);
      });
};

export const FixLevelReducer = (defaultState) => handleActions({
  loadFixLevelData,
  [setFixLevel](state, action = {}) {
    const {data} = action.payload || {};
    return data || [];
  },
}, defaultState);

export default FixLevelReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/FixLevelReducer.js